export default (state, action) => {
  const designs = action.payload;

  return {
    ...state,
    designs,
  };
};
